module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_10y_y.f8079d69.csv";